<div class="admin-page logs-page">
    <div class="admin-toolbar">
        <div class="admin-search">
            <mat-icon>search</mat-icon>
            <input
                type="search"
                placeholder="Buscar animal"
                #searchInput
                (keyup)="onSearchChange(searchInput.value)"
                aria-label="Buscar logs por animal"
            />
        </div>
    </div>

    <div class="logs-body">
        @if (groupedLogs.length > 0) {
        <div class="groups">
            @for (group of groupedLogs; track group) {
            <details class="group" open>
                <summary>
                    <span class="g-name">{{ group.animal.name }}</span>
                    <span class="g-reg">{{ group.animal.register || 'Sem registro' }}</span>
                    <span class="g-count">{{ group.logs.length }}</span>
                </summary>
                <div class="events">
                    @for (log of group.logs; track log) {
                    <div class="event" [class.fail]="isFail(log.result)">
                        <div class="ev-main">
                            <b>{{ log.operation | formatLogOperation }}</b>
                            <small>{{
                                $safeNavigationMigration(log.result?.end) | date: 'dd/MM/yyyy HH:mm'
                            }}</small>
                            @if (isFail(log.result)) {
                            <span class="fail-msg">{{ log.result.data?.message }}</span>
                            }
                        </div>
                        <span class="pill" [class.ok]="!isFail(log.result)" [class.bad]="isFail(log.result)">
                            {{ isFail(log.result) ? 'Falha' : 'OK' }}
                        </span>
                    </div>
                    }
                </div>
            </details>
            }
        </div>
        }

        @if (isLoading) {
        <div class="state">
            <mat-spinner diameter="28"></mat-spinner>
        </div>
        }

        @if (!isLoading && hasMoreLogs && groupedLogs.length > 0) {
        <div class="more">
            <button type="button" mat-stroked-button color="primary" (click)="loadMore()">Carregar mais</button>
        </div>
        }

        @if (!hasMoreLogs && !isLoading && groupedLogs.length > 0 && currentPage > 0) {
        <p class="end">Fim dos resultados</p>
        }

        @if (!isLoading && groupedLogs.length === 0) {
        <div class="state">Nenhum log encontrado</div>
        }
    </div>
</div>
